import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useAtom } from 'jotai';
import { capitalize } from 'lodash';

import {
  type AllSensorRuleFile,
  rulesDeleteDialogAtom,
  rulesDeleteDialogOpenAtom,
  useDeleteSensorRule
} from '@/pages/Administration/AdministrationRules';

const RulesDeleteDialog = () => {
  const [isRulesDeleteDialogOpen, setIsRulesDeleteDialogOpen] = useAtom(
    rulesDeleteDialogOpenAtom
  );
  const [rule] = useAtom(rulesDeleteDialogAtom);
  const deleteSensorRule = useDeleteSensorRule();

  const handleClose = () => {
    setIsRulesDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    deleteSensorRule.mutate(rule as AllSensorRuleFile);
  };

  return (
    <Dialog
      open={isRulesDeleteDialogOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Delete {capitalize(rule?.level)} Sensor File: <i>{rule?.file_name}</i>{' '}
        (#{rule?.id})
      </DialogTitle>
      <DialogContent sx={{ position: 'relative' }}>
        <Box sx={{ my: 2 }}>
          <Alert severity="warning">
            This action is irreversible, are you sure you want to delete this
            sensor file?
          </Alert>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button color="error" variant="contained" onClick={handleDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RulesDeleteDialog;
